import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const EmailVerificationPending = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  
  const [resendEmail, setResendEmail] = useState(email);
  const [resendStatus, setResendStatus] = useState('');

  const handleResend = async () => {
    if (!resendEmail) return;
    try {
      setResendStatus('sending');
      const response = await fetch('/api/auth/resend-verification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resendEmail })
      });
      const data = await response.json();
      setResendStatus(data.success ? 'sent' : 'error');
    } catch (err) {
      setResendStatus('error');
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0d47a1 0%, #1a73e8 50%, #42a5f5 100%)',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: '20px'
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px',
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>📬</div>
        <h2 style={{ color: '#1a1a1a', marginBottom: '12px', fontSize: '24px' }}>
          Verify Your Email
        </h2>
        <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6', marginBottom: '8px' }}>
          We've sent a verification link to:
        </p>
        {email && (
          <p style={{ color: '#1a73e8', fontWeight: '600', fontSize: '16px', marginBottom: '24px' }}>
            {email}
          </p>
        )}
        <p style={{ color: '#888', fontSize: '14px', lineHeight: '1.5', marginBottom: '32px' }}>
          Click the link in the email to activate your account. 
          The link expires in 24 hours.
        </p>

        <div style={{ 
          background: '#f5f5f5', borderRadius: '12px', padding: '20px', 
          marginBottom: '24px', textAlign: 'left' 
        }}>
          <p style={{ color: '#555', fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>
            Didn't receive the email?
          </p>
          <ul style={{ color: '#666', fontSize: '13px', lineHeight: '1.8', paddingLeft: '20px', margin: '0 0 16px' }}>
            <li>Check your spam/junk folder</li>
            <li>Make sure you entered the correct email</li>
            <li>Wait a few minutes for it to arrive</li>
          </ul>
          
          <input
            type="email"
            value={resendEmail}
            onChange={(e) => setResendEmail(e.target.value)}
            placeholder="your@email.com"
            style={{
              width: '100%', padding: '10px 12px', borderRadius: '8px',
              border: '1px solid #ddd', fontSize: '14px', marginBottom: '10px',
              boxSizing: 'border-box'
            }}
          />
          <button
            onClick={handleResend}
            disabled={resendStatus === 'sending' || !resendEmail}
            style={{
              width: '100%', padding: '10px', borderRadius: '8px',
              background: resendStatus === 'sent' ? '#2e7d32' : '#1a73e8',
              color: '#fff', border: 'none', fontSize: '14px', 
              fontWeight: '600', cursor: 'pointer',
              opacity: (!resendEmail || resendStatus === 'sending') ? 0.6 : 1
            }}
          >
            {resendStatus === 'sending' ? 'Sending...' :
             resendStatus === 'sent' ? '✓ New link sent!' :
             resendStatus === 'error' ? 'Failed — Try again' :
             'Resend Verification Email'}
          </button>
        </div>

        <a 
          href="/login" 
          style={{ color: '#1a73e8', textDecoration: 'none', fontSize: '14px' }}
        >
          ← Back to Login
        </a>
      </div>
    </div>
  );
};

export default EmailVerificationPending;
